import { lazy, useContext, useEffect } from "react";
import { Box, Paper } from "@mui/material";

import { useUserData } from "src/context/userContext";

import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { RefreshIcon } from "src/components/icons/ActionIcons";
import { FPTilauksetContext } from "src/context/FPTilauksetContext";
import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import { pvmStringLong, scroll6IfTop } from "src/components/js/statics1";
import { StyledButton } from "src/components/styled/StyledButton";
import { StyledContainer } from "src/components/styled/StyledContainer";
import FPTilauksetFilterSources from "./components/FPTilauksetFilterSources";

const FPTilauksetFilterCheckboxesTimelime = lazy(() =>
  import("./components/FPTilauksetFilterCheckboxesTimelime")
);
const TarkistaVapaatAjatButton = lazy(() =>
  import("src/components/TarkistaVapatAjat/TarkistaVapaatAjatButton")
);
const UusiTilausButton = lazy(() => import("src/components/buttons/uusiTilaus/UusiTilausButton"));
const FPEiTilauksia = lazy(() => import("./components/FPEiTilauksia"));
const FPTilaukset = lazy(() => import("./components/FPTilaukset"));

const _fPTilauksetPvmSelector = import("./components/FPTilauksetPvmSelector");
const FPTilauksetPvmSelector = lazy(() => _fPTilauksetPvmSelector);

const _fPTilauksetSuodataTextBox = import("./components/FPTilauksetSuodataTextBox");
const FPTilauksetSuodataTextBox = lazy(() => _fPTilauksetSuodataTextBox);

export default function FrontPageAuth() {
  const { user } = useUserData();
  const hasMultipleKeikkas = user && user.settings.hasMultipleKeikkas;

  const { dates, setDates, allKeikat, isLoaded, isLoading, setIsLoading, reloadAll, setSuodata } =
    useContext(FPTilauksetContext) || {};

  useEffect(() => {
    document.title = "Tilaukset " + pvmStringLong(dates?.startDate);
  }, [dates?.startDate]);

  useEffect(() => {
    localStorage.setItem("lastKnownUrl", window.location.pathname);
    scroll6IfTop();
  }, []);

  const handleRefreshClick = async () => {
    setIsLoading(true);
    await reloadAll();
    setIsLoading(false);
  };

  return (
    <AuthAccess page="list" showError>
      <LazyLoader>
        <Box
          className="boxContainer"
          sx={{ transition: "all 0.5s ease-in-out", minHeight: "500px" }}>
          <Paper
            elevation={2}
            className="stepContainer"
            sx={{ minHeight: "90vh", padding: "20px" }}>
            <div
              className="noPrint"
              style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <UusiTilausButton height={"45px"} />
              <TarkistaVapaatAjatButton
                txt="TARKISTA SAATAVUUS"
                height={45}
                requireCaptcha={false}
                disabled={isLoading}
              />
            </div>
            <div className="noPrint">
              <StyledContainer
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 6,
                  // height: "100%",
                  alignItems: "center",
                }}>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    gap: 6,
                    alignItems: "center",
                    height: "100%",
                  }}>
                  <StyledButton
                    variant="outlined"
                    onClick={handleRefreshClick}
                    disabled={isLoading}
                    height={"50px"}
                    sx={{ opacity: isLoading ? 0.5 : 1 }}>
                    <RefreshIcon isLoading={isLoading} />
                  </StyledButton>
                  <FPTilauksetPvmSelector
                    disabled={isLoading}
                    showNextDayButton
                    showPrevDayButton
                    showTodayButton
                    setDates={setDates}
                  />
                </div>
                <div style={{ flex: 3 }}>
                  <FPTilauksetSuodataTextBox setSuodata={setSuodata} disabled={isLoading} />
                </div>
              </StyledContainer>
              <StyledContainer>
                <FPTilauksetFilterSources />
                <div style={{ height: "2px" }} />
                <FPTilauksetFilterCheckboxesTimelime />
              </StyledContainer>
            </div>
            {isLoaded && (
              <LazyLoader>
                <FPTilaukset />
              </LazyLoader>
            )}
            {isLoaded && !hasMultipleKeikkas && allKeikat && allKeikat.length == 0 && (
              <FPEiTilauksia />
            )}
          </Paper>
        </Box>
      </LazyLoader>
    </AuthAccess>
  );
}
